import React from "react";
import LoginForm from "../../components/LoginForm/LoginForm";
import { Link } from "react-router-dom";
import styles from "./LoginPage.module.css";
import logo from '../../assets/house-icon-red.png';

export default function LoginPage() {
    return (
        <div className={styles.component}>
            <div className={styles.inner}>
                <div className={styles.headerL}>
                    <img src={logo} width={60} height={60}/>
                    <h1 className={styles.topText}>Welcome to</h1> 
                    <h1 className={styles.bottomText}>HomeMate</h1>
                </div>
                <div className={styles.formBlockR}>
                    <LoginForm/> 
                    
                </div>
            </div>
        </div>
    )
}